import http from './http'
const refreshRoute = '/auth/refresh'
const authRoute = '/auth'

export default {
    async checkUserAuthenticated () {
        return http.get(`${authRoute}/user-authenticated`)
    },
    async getLoggedInUserPermissions () {
        return http.get(`/permission/owner`)
    },
    async getRoles () {
        return http.get(rolesRoute)
    },
    async refreshToken () {
        return http.post(refreshRoute)
    }
}
